// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Date Range Picker Styles - shared look with CostDashboard */
.custom-date-range-picker {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: white;
  overflow: hidden;
}

.custom-date-range-picker .rdrCalendarWrapper,
.custom-date-range-picker .rdrDateRangeWrapper {
  font-family: inherit;
  color: inherit;
  background: inherit;
}

.custom-date-range-picker .rdrSelected,
.custom-date-range-picker .rdrInRange,
.custom-date-range-picker .rdrStartEdge,
.custom-date-range-picker .rdrEndEdge {
  background: var(--joy-palette-primary-500) !important;
}

.custom-date-range-picker .rdrDayNumber span {
  font-weight: 400;
  color: inherit;
}

.custom-date-range-picker .rdrNextPrevButton {
  background: var(--joy-palette-background-level1);
  border: 1px solid var(--joy-palette-divider);
}

.custom-date-range-picker .rdrNextPrevButton:hover {
  background: var(--joy-palette-background-level2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminCostDashboard/styles/styles.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD","sourcesContent":["/* Custom Date Range Picker Styles - shared look with CostDashboard */\n.custom-date-range-picker {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  background: white;\n  overflow: hidden;\n}\n\n.custom-date-range-picker .rdrCalendarWrapper,\n.custom-date-range-picker .rdrDateRangeWrapper {\n  font-family: inherit;\n  color: inherit;\n  background: inherit;\n}\n\n.custom-date-range-picker .rdrSelected,\n.custom-date-range-picker .rdrInRange,\n.custom-date-range-picker .rdrStartEdge,\n.custom-date-range-picker .rdrEndEdge {\n  background: var(--joy-palette-primary-500) !important;\n}\n\n.custom-date-range-picker .rdrDayNumber span {\n  font-weight: 400;\n  color: inherit;\n}\n\n.custom-date-range-picker .rdrNextPrevButton {\n  background: var(--joy-palette-background-level1);\n  border: 1px solid var(--joy-palette-divider);\n}\n\n.custom-date-range-picker .rdrNextPrevButton:hover {\n  background: var(--joy-palette-background-level2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
